import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSliderModule} from "@angular/material/slider";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { OfflineactivationComponent } from './offlineactivation/offlineactivation.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import {MatIconModule} from "@angular/material/icon";
import {HttpClientModule} from "@angular/common/http";
import { HomepageComponent } from './homepage/homepage.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { RegistrationComponent } from './registration/registration.component';
import { WebregistrationComponent } from './webregistration/webregistration.component';
import {MatStepperModule} from '@angular/material/stepper';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DesktopregistrationComponent } from './desktopregistration/desktopregistration.component';
import {ThankyoudesktopComponent} from "./thankyoudesktop/thankyoudesktop.component";

@NgModule({
  declarations: [
    AppComponent,
    OfflineactivationComponent,
    ConfirmationComponent,
    HomepageComponent,
    OnboardingComponent,
    ThankyouComponent,
    RegistrationComponent,
    WebregistrationComponent,
    DesktopregistrationComponent,
    ThankyoudesktopComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    MatFormFieldModule,
    FormsModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTooltipModule,
    MatCheckboxModule
  ],
  bootstrap: [AppComponent],
  entryComponents: [],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
  ]
})
export class AppModule { }
